<template>
  <div class="pickup">
    <form
      class="q-gutter-lg"
      @submit.prevent="submitPickup"
    >
      <div class="title">
        Расформировать заказ через N часов после сборки заказа
      </div>
      <div class="row">
        <q-input
          v-model="vCancelInterval"
          class="form-group__control col-xs-2"
          square
          outlined
          dense
        />
      </div>
      <div class="intervals-header">
        <div class="title">
          Интервалы
        </div>
        <div
          v-ripple
          class="icon"
          @click="addInterval"
          v-html="icAdd"
        />
      </div>
      <div class="row">
        <Intervals />
      </div>
      <div class="row reverse">
        <div class="col-sm-3 col-12">
          <q-btn
            type="submit"
            class="full-width"
            size="16px"
            label="Сохранить"
            unelevated
            color="primary"
          />
        </div>
      </div>
    </form>
  </div>
</template>

<script>
/**
 * Компонент отображает вкладку с настройкой интервалов
 * @module PageShop/Component/SelectedStore/Pickup
 * @requires vuex
 * @requires Images/icon/ic-add.svg
 * @requires PageShop/components/Intervals
 * @vue-computed {Number} vCancelInterval - расформировать заказ через (часов)
 */
import icAdd from 'Images/icon/ic-add.svg'
import Intervals from 'PageShop/components/Intervals'
import { createNamespacedHelpers } from 'vuex'

const { mapState, mapActions, mapMutations } = createNamespacedHelpers('storeModule/pickupModule')

export default {
  name: 'Pickup',
  components: {
    Intervals
  },
  data: () => ({
    icAdd
  }),
  computed: {
    ...mapState(['pickup']),
    vCancelInterval: {
      get() { return this.pickup.cancelInterval },
      set(val) { this.updatePickup({ cancelInterval: val }) }
    }
  },
  methods: {
    ...mapActions(['submitPickup']),
    ...mapMutations(['updatePickup', 'addInterval'])
  }
}
</script>

<style lang="scss" scoped>
.pickup {
  padding: 20px;

  .title {
    font-size: 18px;
    font-weight: 600;
  }

  .intervals-header {
    display: flex;
    justify-content: flex-start;
    align-items: center;

    .icon {
      position: relative;

      margin-left: 20px;

      width: 36px;
      height: 36px;

      border-radius: 36px;

      cursor: pointer;
    }
  }
}
</style>
